import React from 'react';
import { TranslateProvider } from "../context/Translate";
import ThemeProvider from "../constants/theme/ThemeProvider";
import { ErrorBoundary } from "./ErrorBoundary";
import { jsx as ___EmotionJSX } from "@emotion/react";
/**
 * Common HOC Wrapper which includes the most commonly used HOC wrappers to
 * simplify integrations in non-React application
 *
 * @param Component Target component to render
 * @param props Common HOC props
 *
 * @returns Wrapped Component
 */
export function withCommon(Component, props) {
  if (props === void 0) {
    props = {};
  }
  var {
    errorBoundaryProps = {},
    partialTheme = {},
    translateService = key => key
  } = props;
  var WrappedComponent = props => {
    return ___EmotionJSX(ErrorBoundary, errorBoundaryProps, ___EmotionJSX(ThemeProvider, {
      resetCSS: false,
      partialTheme: partialTheme
    }, ___EmotionJSX(TranslateProvider, {
      translate: translateService
    }, ___EmotionJSX(Component, props))));
  };
  var componentDisplayName = Component.displayName || Component.name;
  WrappedComponent.displayName = "withCommon" + componentDisplayName;
  return WrappedComponent;
}